import styled from 'styled-components';

export const WidgetContainer = styled.div`
  padding-top: 12px;
  padding-left: ${(props) => (props.stroller ? '20px' : '0')};
`;
